export const decorateEditorialHtml = (text?: string) => {
  if (!text) {
    return { __html: "" };
  }

  const htmlWithStyle = text
    .replace(/<h[1-9]/gi, '$& class="uitk-type-heading-500"')
    .replace(/<br>/gi, "")
    .replace(/<ul/gi, '$& class="uitk-type-list-300 all-y-margin-two"')
    .replace(/<ol/gi, '$& class="uitk-type-list-300 all-y-margin-two"')
    .replace(/<\/br>/gi, "");

  return { __html: htmlWithStyle };
};
